import { IAddress } from './user/address.interfaces';
import { z } from 'zod/v4';
import { IBankData } from './user/bank-data.interfaces';

export interface IChangePasswordRequest {
  oldPassword: string;
  newPassword: string;
}

export enum EUserRight {
  CmsUser = 3000,
  CmsAdmin = 3001,
}

export interface UserDto {
  userId?: string;
  firstName: string;
  lastName: string;
  email: string;
  birthDate: string;
  salutation: string;
  phoneNumber: string;
  dateOfTermsAgreement?: Date | null;
  address: IAddress;
  referenceToCustomer: string;
  profilePictureId?: string;
}

export interface IAmconSystemUser {
  id?: string;
  firstName: string;
  lastName: string;
  street: string;
  houseNumber: string;
  zipCode: string;
  city: string;
  additional: string;
  country: string;
  phoneNumber: string;
  eMailAddress: string;
  birthDate: string;
}

export const DEFAULT_USER: UserDto = {
  userId: '',
  firstName: '',
  lastName: '',
  email: '',
  birthDate: '',
  salutation: '',
  phoneNumber: '',
  dateOfTermsAgreement: null,
  referenceToCustomer: '',
  address: {
    id: '',
    firstName: '',
    lastName: '',
    street: '',
    houseNumber: '',
    city: '',
    country: '',
    additional: '',
    postCode: '',
  },
  profilePictureId: '',
};

export interface IUser {
  userId?: string;
  email: string;
  dateOfTermsAgreement?: Date;
  deletedAt?: Date;
  isActive?: boolean;
  referenceToCustomer: string;
  bankDataPreference?: IBankData;
  salutation: string;
  profilePictureId?: string;
}

export const USER_SCHEMA: z.ZodType<IUser> = z.object({
  userId: z.uuid().optional(),
  email: z.string(),
  dateOfTermsAgreement: z.date().optional(),
  deletedAt: z.date().optional(),
  isActive: z.boolean(),
  referenceToCustomer: z.string(),
  salutation: z.string(),
});

export interface UserDtoWithProfilePictureBuffer extends UserDto {
  profilePicture: Buffer<ArrayBuffer>;
}

export interface IProfilePictureFile {
  data: ArrayBuffer;
  type: string;
}
